import { CycleCountRuleStatus as CycleCountRuleStatusEnum } from "@redotech/crdb-enums/inventory/cycle-count-rule-status";
import { CycleCountRuleType as CycleCountRuleTypeEnum } from "@redotech/crdb-enums/inventory/cycle-count-rule-type";
import * as z from "zod";
import { abcRuleDataSchema } from "./rule-types/abc";
import { customRuleDataSchema } from "./rule-types/custom";

export const cycleCountRuleTypeSchema = z.enum(CycleCountRuleTypeEnum);

export type CycleCountRuleType = `${CycleCountRuleTypeEnum}`;

export const cycleCountRuleStatusSchema = z.enum(CycleCountRuleStatusEnum);

export type CycleCountRuleStatus = `${CycleCountRuleStatusEnum}`;

export const randomRuleDataSchema = z.object({});
export type RandomRuleData = z.infer<typeof randomRuleDataSchema>;

export const exceptionRuleDataSchema = z.object({});
export type ExceptionRuleData = z.infer<typeof exceptionRuleDataSchema>;

export const cycleCountRuleDataSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("abc"), data: abcRuleDataSchema }),
  z.object({ type: z.literal("custom"), data: customRuleDataSchema }),
  z.object({ type: z.literal("random"), data: randomRuleDataSchema }),
  z.object({ type: z.literal("exception"), data: exceptionRuleDataSchema }),
]);

export type CycleCountRuleData = z.infer<typeof cycleCountRuleDataSchema>;

export type CycleCountRule = CycleCountRuleData & { liveAt: Date };
